import React from "react";
import "./aboutCrosswalk.css";

const AboutCrosswalk = () => {
  return (
    <div className="about-cred-wrapper">
      <div className="max-width flex flex-col about-cred">

        {/* About Section */}
        <div className="about-section flex flex-col sec">
          <div className="sec-heading">about Crosswalk</div>
          <div className="sec-para">
            Crosswalk is a smart investing and portfolio management platform
            built with AI. it helps you track markets, find good chances, and
            grow your money in a simple and safe way. our goal is to make
            investing clear, easy, and smart for everyone.
          </div>
        </div>

        {/* How Crosswalk Helps Users */}
        <div className="reward-section flex flex-col sec">
          <div className="sec-heading">how does Crosswalk help you?</div>
          <div className="sec-para">
            Crosswalk uses real-time data, machine learning, and deep market
            analysis to guide your trades and investments. whether it's stocks,
            crypto, forex, or bonds—Crosswalk makes decisions easier with clean
            insights and smart alerts.
          </div>
        </div>

        {/* Features Section */}
        <div className="earn-section flex flex-col sec">
          <div className="sec-heading">what can you do on Crosswalk?</div>
          <div className="sec-para">
            with Crosswalk, you get a full set of tools to manage and grow your
            money: <br />
            - invest in stocks, crypto, forex, and bonds <br />
            - track markets 24/7 with AI-driven updates <br />
            - get simple alerts on price moves and trends <br />
            - view clear reports on gains, losses, and risks <br />
            - see all your assets in one easy dashboard <br />
            - use fast trade execution backed by smart models <br />
            - get insights tailored to your goals
          </div>
        </div>

        {/* Member Benefits Section */}
        <div className="member-section flex flex-col sec">
          <div className="sec-heading">what do you get as a Crosswalk user?</div>
          <div className="sec-para">
            as a Crosswalk user, you get a clean, safe, and smart investing
            experience: <br />
            - strong encryption and full data safety <br />
            - real-time tracking of your full portfolio <br />
            - AI tools that spot good chances early <br />
            - smooth investing across markets <br />
            - simple insights to guide every step <br />
            - a platform built for both new and pro investors
          </div>
        </div>

      </div>
    </div>
  );
};

export default AboutCrosswalk;
